import Vue from 'vue'
import Vuex from 'vuex'

import { About, Gallery } from './classes'

Vue.use(Vuex)

export const store = new Vuex.Store({
  state: {
    helpers: {
      galleryIndex: null,
      overflow: 'visible'
    },

    wolfmap: {
      currentDetail: null,
      currentView: 'appWolfmap',
      animation: 'fade'
    },

    about: new About(2),

    gallery: new Gallery(5, 9, 3, 5),

    landscape: {
      audio: '',
      backgroundImg: '',
      intro: '',
      title: '',
      maps: [
        {
          name: '',
          backgroundImg: '',
          mapImage: ''
        },
        {
          name: '',
          backgroundImg: '',
          mapImage: ''
        }
      ]
    },

    shared: {
      backgroundImg: ''
    },

    explore: {
      audio: '',
      backgroundImg: '',
      intro: '',
      mapDetail: []
    }
  },

  getters: {
    aboutContent: state => state.about,
    galleryContent: state => state.gallery,
    landscapeContent: state => state.landscape,
    sharedContent: state => state.shared,
    wolfContent: state => state.explore,
    helperState: state => state.helpers,
    wolfState: state => state.wolfmap
  },

  mutations: {
    SET_PROP (state, payload) {
      let parent = payload.parent
      let key = payload.key
      let value = payload.value

      state[parent][key] = value
    },

    UPDATE_PROPS (state, payload) {
      let parent = payload.parent
      let updates = payload.updates
      state[parent] = updates
    }
  },

  actions: {
    getLocalData ({ commit }, fileName) {
      Vue.http.get('./static/data/' + fileName + '.json')
      .then(response => {
        return response
      })
      .then(data => {
        let payload = {
          parent: fileName,
          updates: data.body
        }
        commit('UPDATE_PROPS', payload)
      })
      .catch(err => {
        console.log(err)
      })
    },

    setProp ({ commit }, payload) {
      commit('SET_PROP', payload)
    },

    updateProps ({ commit }, payload) {
      commit('UPDATE_PROPS', payload)
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/store.js